import { addErrorNotification, getOrderItemCount, NotificationType } from '@vista/omnichannel-components-domain';
import { getIdForComponentNotification } from '../../../utils/get-id-for-component-notification';
export const validateItemSelection = (minimumRequiredItems, template, i18n) => {
    const totalSelectedItems = getOrderItemCount();
    if (totalSelectedItems < minimumRequiredItems) {
        const message = i18n.template(template, {
            minimum: minimumRequiredItems
        });
        addErrorNotification({
            id: getIdForComponentNotification('item-picker', NotificationType.Error, 'invalid-selection'),
            messages: [message]
        });
        return false;
    }
    return true;
};
